import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, TextInput } from '../../../types'
import { CmsConverterService, defaultTextInput } from '../../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class PanelRowRelatedVideosLinkConverter extends CmsConverterService<PanelRowRelatedVideosLinkData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      videoId: formData.st_video ?? '',
      descriptionOverlay: formData.st_description_text_overlay ?? defaultTextInput,
      captionOverlay: formData.st_caption_text_overlay ?? defaultTextInput,
      tooltip: formData.st_tooltip_text ?? ''
    }
  }
}

export const PANEL_ROW_RELATED_VIDEOS_LINK_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, PanelRowRelatedVideosLinkData>>('PanelRowRelatedVideosLinkConverter')

export interface PanelRowRelatedVideosLinkData extends ConvertedComponentData {
  videoId: string;
  captionOverlay: TextInput;
  descriptionOverlay: TextInput;
  tooltip: string;
}
